import * as React from "react";
import styled from "styled-components";

import { OverlayTitle } from "@hubper/core-ui/typo";

import { useModal } from "@hubper/core-ui/hooks";
import { withModal } from "@hubper/core-ui/hocs";
import { TextInput, Button } from "@hubper/core-ui/elements";

const Base = styled.div`
  padding: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  user-select: none;
`;

const Modal = withModal({ height: "auto", width: 400 }, ({ onCommit }: any) => {
  const [value, setValue] = React.useState("");

  React.useEffect(() => {
    function onKey(evt: any) {
      if (evt.key === "Enter" && value.length > 0) {
        onCommit(value);
      }
    }

    document.addEventListener("keydown", onKey);

    return () => {
      document.removeEventListener("keydown", onKey);
    };
  }, [value, onCommit]);

  return (
    <Base>
      <OverlayTitle style={{ textAlign: "center", marginBottom: 24 }}>
        Add namespace
      </OverlayTitle>
      <TextInput
        label="Title"
        value={value}
        stretch
        onChange={(evt: any) => setValue(evt.target.value)}
        style={{ marginBottom: 24 }}
        // @ts-ignore
        autoFocus
      />
      <Button
        disabled={value === ""}
        type="color"
        onClick={() => onCommit(value)}
        text="Add"
      />
    </Base>
  );
});

type Props = {
  onCommit: (title: string) => void;
};

export default function useShowAddNamespace() {
  const { showModal, hideModal } = useModal();

  return (props: Props) =>
    showModal(
      <Modal
        onCommit={(value: string) => {
          hideModal();
          props.onCommit(value);
        }}
      />
    );
}
